<template>
	<div class="ef-box">
		<div class="ef-section">Feed / esclusioni</div>
		<div class="ef-grid">
			<v-select
				v-model="setting.category"
				:items="categorie"
				item-text="original"
				return-object
				label="Categoria principale"
				dense
				outlined
				hide-details
				background-color="white"
				class="ef-full"
			></v-select>
			<v-select
				v-model="esclusi.brands"
				:items="brands"
				item-text="name"
				item-value="_id"
				label="Brand esclusi"
				multiple
				small-chips
				deletable-chips
				dense
				outlined
				hide-details
				background-color="white"
			></v-select>
			<v-autocomplete
				v-model="esclusi.categories"
				:items="listcategories"
				item-value="_id"
				item-text="string"
				label="Categorie escluse"
				clearable
				multiple
				small-chips
				deletable-chips
				dense
				outlined
				hide-details
				background-color="white"
			></v-autocomplete>
			<v-autocomplete
				v-model="esclusi.items"
				:items="listitemsIT"
				:search-input.sync="ricerca"
				item-value="variants._id"
				:item-text="item => `${item?.trans.name} ${item?.variants?.sku} ${item?.variants?.ean}`"
				return-object
				label="Prodotti esclusi (cerca per nome, SKU o EAN)"
				clearable
				multiple
				no-filter
				small-chips
				deletable-chips
				dense
				outlined
				hide-details
				background-color="white"
				class="ef-full"
			></v-autocomplete>
		</div>
	</div>
</template>

<script>
// esclusioni del feed prodotti (Google Merchant, Bing, Facebook Marketplace):
// i campi scrivono su modello.setting.category e modello.setting.config.excluded come prima
export default {
	name: 'EsclusioniFeed',
	props: {
		modello: { type: Object, required: true },
		categorie: { type: Array, default: () => [] },
		brands: { type: Array, default: () => [] },
		listcategories: { type: Array, default: () => [] },
		listitemsIT: { type: Array, default: () => [] },
		// testo di ricerca prodotti: vive nella pagina, che ha il watcher che interroga il backend (.sync)
		searchItemIT: { type: String, default: '' },
	},
	computed: {
		setting() {
			return this.modello.setting || {};
		},
		esclusi() {
			return (this.setting.config && this.setting.config.excluded) || {};
		},
		ricerca: {
			get() {
				return this.searchItemIT;
			},
			set(v) {
				this.$emit('update:searchItemIT', v);
			},
		},
	},
};
</script>

<style scoped>
.ef-box {
	margin-top: 16px;
}
.ef-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.ef-grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 12px 16px;
}
.ef-full {
	grid-column: 1 / -1;
}
@media (max-width: 768px) {
	.ef-grid {
		grid-template-columns: 1fr;
	}
}
</style>
